import { FormElement, FormError, FormSubmissionResponse, NextBehavior } from '@uplift/types';
import { restClient } from '../../client';

export type NextElementInput = {
  submission_id: string;
  form_element_id: string;
  form_element_answer_id?: string;
  response_text?: string;
  next_behavior: NextBehavior;
};

export type NextElementOutput =
  | {
    error: FormError;
  }
  | {
    element: FormElement;
    response: FormSubmissionResponse;
  };

export const nextElement = (data: NextElementInput) =>
  restClient.request<NextElementOutput>('/api/v1/form/next_element', {
    method: 'POST',
    data
  });
